import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setScreen,
  selectDarkMode,
  setDarkMode,
} from "_redux/slices/main-screen/render-screen";

const darkMode = false;

export const BACKGROUND = "#ffffff";

export const LIGHT_RED = "#FEEBEC";
export const DARK_RED = "#BB2025";

export const ARRIVALS_GREEN = "#29C40D";
export const LIGHT_GREEN = "#29C40D";
export const DARK_GREEN = "#087702";

export const GRAY_LIGHT = "#F7F8F9";
export const GRAY_MEDIUM = "#cacaca";
export const GRAY_DARK = "#8a8a8a";

export const ORANGE = "#ebb71c";

export const DARK_BLUE = "#2b3087";

export const PRM_GRAY = "#707070";

export const PRM_BLUE = "#3b7ab4";
export const PRM_LIGHT_BLUE = darkMode ? "white" : "#307FE2";
export const PRM_DARK_BLUE = "#1e22aa";
export const TEXT_COLOR = darkMode ? "white" : "black";
export const SIDEBAR_COLOR = darkMode ? "black" : "#307FE2";
export const BACKGROUND_COLOR = darkMode ? "#121212" : "white";


export const SUNFLOWER_YELLOW = "#dbdb12";

export const DAA_GREEN = "#417c3d";

export const HEATMAP_01 = "#03a116";
export const HEATMAP_02 = "#2be03d";
export const HEATMAP_03 = "#e6eb5b";
export const HEATMAP_04 = "#f07373";
export const HEATMAP_05 = "#ff0000";
export const HEATMAP_EMPTY = "#e6e6e6";


// accent colors
export const PRM_BLUE_ACCENT = '#E6F0FB';
export const PRM_LIGHT_BLUE_BG = '#CEDEED'